import css from './ItemAvailability.module.css';
import { CheckCircleIcon } from '@shared/Icons/CheckCircleIcon';

interface ItemAvailabilityProps {
    qtyFromStore?: number | string;
    className?: string;
}

export const ItemAvailability: React.FC<ItemAvailabilityProps> = ({
    qtyFromStore,
    className,
}) => {
    const parsedQty = Number(qtyFromStore);
    const isNumber = !isNaN(parsedQty);

    if (isNumber && parsedQty > 0) {
        return (
            <div
                className={`${css.availableItemsNumber} ${className ? className : ''}`}
            >
                <CheckCircleIcon width={14} height={14} />
                <div>{`${parsedQty} available`}</div>
            </div>
        );
    }

    if (isNumber && parsedQty === 0) {
        return (
            <div
                className={`${css.outOfStockItems} ${className ? className : ''}`}
            >
                Out of stock
            </div>
        );
    }

    return (
        <div className={`${css.outOfStockItems} ${className ? className : ''}`}>
            No limit
        </div>
    );
};
